import { fromJS } from 'immutable';

import { setDropdownValuesType } from './ResultsPaginationConstants';

export const initialState = fromJS({
  dropdownValues: []
});

export function reducer (state = initialState, action) {
  switch(action.type) {
    case setDropdownValuesType: {
      const { dropdownValues } = action;
      return state.set('dropdownValues', dropdownValues);
    }
    default: {
      return state;
    }
  }
}
